
    import '/home/ec2-user/Youlify-Design/docs/blog/testing-migrate.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/home/ec2-user/Youlify-Design/docs/blog/testing-migrate.en-US.md?type=demo')
};